import * as React from 'react'

const SvgCheckmarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path d="M3.6 8.8L8 13.2l7.6-7.6.9.9L8 15 2.7 9.7l.9-.9z" fill="#163250" />
  </svg>
)

export default SvgCheckmarkIcon
